import { TrackingEvent } from '../tracking/types';

export enum FlutterInappwebviewHandler {
  TRACK_EVENT = 'trackEvent',
  CLOSE_CASHIER = 'closeCashier',
  TRANSACTION_INIT = 'transactionInit',
}

export interface TransactionInitEvent {
  value: string;
  currency: string;
  playerId: string;
  playerEmail: string;
  playerPhone: string;
}

export type PublishEventData = TrackingEvent | TransactionInitEvent;

export interface FlutterInappwebview {
  callHandler(handler: FlutterInappwebviewHandler, data: TrackingEvent): void;
}
